import dynamic from "next/dynamic";

import { ArticlePage as ArticlePageType } from "~/bff/components/ArticlePage";
import { ArticleTile as ArticleTileType } from "~/bff/components/ArticleTile";
import {
  BffComponentType as Component,
  ComponentsConfig,
} from "~/bff/ComponentsConfig";
import { SearchResultsPage } from "~/components/search-results-page/component";
import { importComponentByName } from "~/helpers/import-component-by-name";

const ClickAndCollectInterrupterPanel = dynamic(async () =>
  importComponentByName(
    import("~/components/click-and-collect-interrupter-panel/component"),
    "ClickAndCollectInterrupterPanel",
  ),
);
const LatestArticlesCarousel = dynamic(async () =>
  importComponentByName(
    import("~/components/latest-articles-carousel/component"),
    "LatestArticlesCarousel",
  ),
);

const RecentlyViewedCarousel = dynamic(async () =>
  importComponentByName(
    import("~/components/recently-viewed-carousel/component"),
    "RecentlyViewedCarousel",
  ),
);
const RelatedArticleTile = dynamic(async () =>
  importComponentByName(
    import("~/components/related-article-tile/component"),
    "RelatedArticleTile",
  ),
);
const ProductCard = dynamic(async () =>
  importComponentByName(
    import("~/components/product-card/component"),
    "ProductCard",
  ),
);
const ProductsCarousel = dynamic(async () =>
  importComponentByName(
    import(
      "~/components/search-results-page/components/products-carousel/component"
    ),
    "ProductsCarousel",
  ),
);
const ArticleTile = dynamic(async () =>
  importComponentByName(
    import("~/components/article-tile/component"),
    "ArticleTile",
  ),
);

export const srpPageConfig: ComponentsConfig = {
  [Component.SEARCH_RESULTS_PAGE]: {
    component: SearchResultsPage,
    overrides: {
      [Component.NEW_IN]: {
        component: ProductsCarousel,
      },
    },
  },
  [Component.CLICK_COLLECT_INTERRUPTER_PANEL]: {
    component: ClickAndCollectInterrupterPanel,
  },
  [Component.RELATED_LATEST_ARTICLES_CAROUSEL]: {
    component: LatestArticlesCarousel,
    overrides: {
      [Component.ARTICLE_PAGE]: {
        component: RelatedArticleTile as ArticlePageType,
      },
    },
  },
  [Component.LATEST_ARTICLES_CAROUSEL]: {
    component: LatestArticlesCarousel,
    overrides: {
      [Component.ARTICLE_PAGE]: {
        component: ArticleTile as ArticlePageType,
      },
      // ArticleTile is used for backward compatibility
      [Component.ARTICLE_TILE]: {
        component: ArticleTile as ArticleTileType,
      },
    },
  },
  [Component.RECENTLY_VIEWED]: {
    component: RecentlyViewedCarousel,
  },
  [Component.PRODUCT_ITEM]: {
    component: ProductCard,
  },
};
